
import { Component, Prop, Vue, } from 'vue-property-decorator';
import { BrandColoursType, isBrandColour, } from '~/utils/resources';

let componentCounter = 0;

@Component
export default class RippleBlock extends Vue {
	@Prop({
		type: String,
		required: true,
		validator(value) {
			return isBrandColour(value);
		},
	})
	colour!: BrandColoursType;

	@Prop({
		type: Number,
		required: true,
		validator(value) {
			return value === 1 || value === 2;
		},
	})
	rippleCount!: number;

	@Prop({
		type: Boolean,
		required: false,
		default: () => false,
	})
	faded!: boolean;

	uuid = `ripple-block__${++componentCounter}`;
}
